// Module
var code = "<article-management\n  article-id=\"vm.article.id\"\n  on-configure=\"vm.openConfiguration\"\n  on-copy=\"vm.openCopyArticle\"\n></article-management>\n";
// Exports
module.exports = code;